import { render } from "./WalletDeposit.vue?vue&type=template&id=6d73d90c&scoped=true"
import script from "./WalletDeposit.vue?vue&type=script&lang=js"
export * from "./WalletDeposit.vue?vue&type=script&lang=js"

import "./WalletDeposit.vue?vue&type=style&index=0&id=6d73d90c&scoped=true&lang=css"
import "./WalletDeposit.vue?vue&type=style&index=1&id=6d73d90c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d73d90c"]])

export default __exports__